import { Map } from 'immutable';

import {
  CONFIRM_REQUEST_REFUSAL_CONTRACT_REQUEST,
  CONFIRM_REQUEST_REFUSAL_CONTRACT_FAILURE,
  CONFIRM_REQUEST_REFUSAL_CONTRACT_SUCCESS,
} from './action';

const initialState = Map({
  type: '',
  payload: [],
});

function reducer(state = initialState, action) {
  const { type } = action;

  if (type === CONFIRM_REQUEST_REFUSAL_CONTRACT_REQUEST) {
    return state
      .updateIn(['type'], () => type)
      .updateIn(['isLoading'], () => true)
      .updateIn(['isLoaded'], () => false)
      .setIn(['payload'], []);
  }

  if (type === CONFIRM_REQUEST_REFUSAL_CONTRACT_FAILURE) {
    const { payload } = action;
    return state
      .updateIn(['type'], () => type)
      .updateIn(['isLoading'], () => false)
      .updateIn(['isLoaded'], () => false)
      .setIn(['payload'], payload);
  }

  if (type === CONFIRM_REQUEST_REFUSAL_CONTRACT_SUCCESS) {
    const { payload } = action;
    return state
      .updateIn(['type'], () => type)
      .updateIn(['isLoading'], () => false)
      .updateIn(['isLoaded'], () => true)
      .setIn(['payload'], payload);
  }

  return state;
}

export default reducer;
